module.exports = {"id":"225555","name":"Ahmet Oğuz","rating":"73","photo":"./data/images/photos/4/225555.png","club":{"name":"Gençlerbirliği","logo":"./data/images/clubs/Genclerbirligi.png"},"positions":["DD","DLD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AhmetOguz0.json
// module id = 135
// module chunks = 0